// const DATE_STRING_OPTIONS: Intl.DateTimeFormatOptions = {
//   year: 'numeric',
//   month: '2-digit',
//   day: '2-digit',
// };

const DATE_TIME_STRING_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};
interface DateTimeFormatters {
  [key: string]: Intl.DateTimeFormat;
}
const dateTimeFormatters: DateTimeFormatters = {};
const getDate = (timeUTC: number): Date => {
  const utcDate = new Date(timeUTC * 1000);
  const date = new Date();
  date.setUTCFullYear(utcDate.getFullYear());
  date.setUTCMonth(0);
  date.setUTCDate(utcDate.getDate());
  date.setUTCMonth(utcDate.getMonth());
  date.setUTCHours(utcDate.getHours());
  date.setUTCMinutes(utcDate.getMinutes());
  date.setUTCSeconds(utcDate.getSeconds());
  date.setUTCMilliseconds(utcDate.getMilliseconds());
  date.setTime(date.getTime() + date.getTimezoneOffset() * 60000);
  return date;
};
export const getLocaleDateTimeString = (
  timeUTC: number,
  dateTimeLocale: string | undefined = undefined,
  options: Intl.DateTimeFormatOptions | undefined = undefined
): string => {
  if (!timeUTC) {
    return '';
  }
  const date = getDate(timeUTC);

  if (Intl && Intl.DateTimeFormat) {
    let formatter: Intl.DateTimeFormat;
    if (!dateTimeFormatters[dateTimeLocale || 'default']) {
      formatter = new Intl.DateTimeFormat(dateTimeLocale, options || DATE_TIME_STRING_OPTIONS);
      dateTimeFormatters[dateTimeLocale || 'default'] = formatter;
    } else {
      formatter = dateTimeFormatters[dateTimeLocale || 'default'];
    }

    return formatter.format(date);
  } else {
    return date.toLocaleTimeString(dateTimeLocale, options || DATE_TIME_STRING_OPTIONS);
  }
};

export const getLocaleDateString = (timeUTC: number, dateTimeLocale: string | undefined = undefined): string => {
  return getLocaleDateTimeString(timeUTC, dateTimeLocale, { year: 'numeric', month: '2-digit', day: '2-digit' });
};

export const getLocaleDateStringWithDiffTime = (
  timeUTC: number,
  dateTimeLocale: string | undefined = undefined,
  maxDiffSeconds = 86400
): string => {
  const date = getDate(timeUTC);
  const now = new Date();
  const diff = Math.floor((now.getTime() - date.getTime()) / 1000);
  if (diff < maxDiffSeconds) {
    if (diff === 0) {
      return 'just now';
    }
    if (diff < 60) {
      return `${diff} sec ago`;
    }
    if (diff < 3600) {
      return `${Math.floor(diff / 60)} min ago`;
    }
    if (diff < 86400) {
      return `${Math.floor(diff / 3600)} hr ago`;
    }
  }
  return getLocaleDateString(timeUTC, dateTimeLocale);
};
